import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M10 9H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 10.52 2 11.08 2 12.2V19m18 0V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 1 17.92 1 16.8 1h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C10 2.52 10 3.08 10 4.2V19m11 0H1M13.5 5h3m-3 4h3m-3 4h3"
    }, null, -1)
  ])))
}
export default { render: render }